import { of } from "rxjs";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { CommandCode, StatusCode } from "../../../utils/network/generated/protoTypes";
import { bugsnagClient } from "../../bugsnag/bugsnagClient";
import { actionErrorThrowError } from "../actionError";
export var pathErrorDefault = function (idNetwork) { return function (action, state$, deps) {
    trackErrorToBugsnag(idNetwork, state$, action);
    return of(actionErrorThrowError(IdErrorCore.UnhandledErrors, action.statusCode));
}; };
var trackErrorToBugsnag = function (idNetwork, state$, action) {
    var errorName = StatusCode[action.statusCode];
    var commandName = CommandCode[action.id];
    bugsnagClient.bugsnag.notify({ name: "UnhandledError", message: commandName + ": " + errorName }, {
        metaData: {
            commandCode: action.id,
            commandName: commandName,
            errorCode: action.statusCode,
            errorName: errorName,
            idNetwork: idNetwork,
            notifyContext: "pathErrorDefault",
        },
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/path/pathErrorDefault.ts
// module id = 1850
// module chunks = 3